import { report, reportServerSide } from '../utils/buryingPoint';

const VERSION = 'V1';
const PAGE_NAME = 'class-choose';

const FIELDS_MAP = {
  // formxx_click
  NAME_CLICK: Symbol(),
  ENGLISH_NAME_CLICK: Symbol(),
  AGE_CLICK: Symbol(),
  LEVEL_CLICK: Symbol(),
  MATH_GRADE_CLICK: Symbol(),
  ENGLISH_GRADE_CLICK: Symbol(),
  EMAIL_CLICK: Symbol(),
  TIMEZONE_CLICK: Symbol(),
  SURE_DATE_CLICK: Symbol(),
  SURE_TIME_CLICK: Symbol(),
  SUBMIT_BUTTON_CLICK: Symbol(),
  // formxx_click_user
  NAME_CLICK_USER: Symbol(),
  ENGLISH_NAME_CLICK_USER: Symbol(),
  AGE_CLICK_USER: Symbol(),
  LEVEL_CLICK_USER: Symbol(),
  MATH_GRADE_CLICK_USER: Symbol(),
  ENGLISH_GRADE_CLICK_USER: Symbol(),
  EMAIL_CLICK_USER: Symbol(),
  TIMEZONE_CLICK_USER: Symbol(),
  SURE_DATE_CLICK_USER: Symbol(),
  SURE_TIME_CLICK_USER: Symbol(),
  SUBMIT_BUTTON_CLICK_USER: Symbol(),
  // others
  SERVERSIDE_PV: Symbol(),
};

// https://wukongedu.feishu.cn/sheets/Z83asPXMxhMPZltJt7ycpefSnef?sheet=1bbe82 业务方约定的命名规范
const EVENT_NAMES_MAP = {
  // formxx_click
  [FIELDS_MAP.NAME_CLICK]: 'g_SecondOrder_formName_Click',
  [FIELDS_MAP.ENGLISH_NAME_CLICK]: 'g_SecondOrder_formEnglishName_Click',
  [FIELDS_MAP.AGE_CLICK]: 'g_SecondOrder_formAge_Click',
  [FIELDS_MAP.LEVEL_CLICK]: 'g_SecondOrder_formLevel_Click',
  [FIELDS_MAP.MATH_GRADE_CLICK]: 'g_SecondOrder_formMathGrade_Click',
  [FIELDS_MAP.ENGLISH_GRADE_CLICK]: 'g_SecondOrder_formEnglishGrade_Click',
  [FIELDS_MAP.EMAIL_CLICK]: 'g_SecondOrder_formEmail_Click',
  [FIELDS_MAP.TIMEZONE_CLICK]: 'g_SecondOrder_formTimezone_Click',
  [FIELDS_MAP.SURE_DATE_CLICK]: 'g_SecondOrder_formSureDate_Click',
  [FIELDS_MAP.SURE_TIME_CLICK]: 'g_SecondOrder_formSureTime_Click',
  [FIELDS_MAP.SUBMIT_BUTTON_CLICK]: 'g_SecondOrder_formSubmitButton_Click',
  // formxx_click_user
  [FIELDS_MAP.NAME_CLICK_USER]: 'g_SecondOrder_formName_ClickUser',
  [FIELDS_MAP.ENGLISH_NAME_CLICK_USER]: 'g_SecondOrder_formEnglishName_ClickUser',
  [FIELDS_MAP.AGE_CLICK_USER]: 'g_SecondOrder_formAge_ClickUser',
  [FIELDS_MAP.LEVEL_CLICK_USER]: 'g_SecondOrder_formLevel_ClickUser',
  [FIELDS_MAP.MATH_GRADE_CLICK_USER]: 'g_SecondOrder_formMathGrade_ClickUser',
  [FIELDS_MAP.ENGLISH_GRADE_CLICK_USER]: 'g_SecondOrder_formEnglishGrade_ClickUser',
  [FIELDS_MAP.EMAIL_CLICK_USER]: 'g_SecondOrder_formEmail_ClickUser',
  [FIELDS_MAP.TIMEZONE_CLICK_USER]: 'g_SecondOrder_formTimezone_ClickUser',
  [FIELDS_MAP.SURE_DATE_CLICK_USER]: 'g_SecondOrder_formSureDate_ClickUser',
  [FIELDS_MAP.SURE_TIME_CLICK_USER]: 'g_SecondOrder_formSureTime_ClickUser',
  [FIELDS_MAP.SUBMIT_BUTTON_CLICK_USER]: 'g_SecondOrder_formSubmitButton_ClickUser',
  // others
  [FIELDS_MAP.SERVERSIDE_PV]: 'g_SecondOrder_ServerSidePV',
};

const doTrack = (field: symbol, options: any, repeat: boolean = false) => {
  const event = EVENT_NAMES_MAP[field];
  const { l } = options;

  report(
    `Track_${PAGE_NAME}__${VERSION}_${l}_${event}`,
    {
      ...options,
      event,
    },
    repeat,
  );
};

const doTrackServerSide = (field: symbol, options: any) => {
  const event = EVENT_NAMES_MAP[field];

  return reportServerSide({
    ...options,
    event,
    serverSide: true,
  });
};
const EVENT_NAME_MAP = {
  SECONDORDER_FORMNAME_CLICK: 'G_SecondOrder_FormName_Click',
  SECONDORDER_FORMLEVEL_CLICK: 'G_SecondOrder_FormLevel_Click',
  SECONDORDER_FORMMATHGRADE_CLICK: 'G_SecondOrder_FormMathGrade_Click',
  SECONDORDER_FORMEMAIL_CLICK: 'G_SecondOrder_FormEmail_Click',
  SECONDORDER_FORMSUREDATE_CLICK: 'G_SecondOrder_FormSureDate_Click',
  SECONDORDER_FORMSURETIME_CLICK: 'G_SecondOrder_FormSureTime_Click',
  SECONDORDER_FORMTIMEAREA_CLICK: 'G_SecondOrder_FormTimeArea_Click',
  SECONDORDER_SUBMITBUTTON_CLICK: 'G_SecondOrder_SubmitButton_Click',
  SECONDORDER_SUBMITBUTTONLEADSID: 'G_SecondOrder_SubmitButtonLeadsId',
  G_LOADING: 'G_LoadingDuration',
  SECONDORDER_VALIDATING: 'G_SecondOrder_Validating',
  SECONDORDER_TIME_MATCHING: 'G_SecondOrder_TimeMatching',
};
export default {
  FIELDS_MAP,
  doTrack,
  doTrackServerSide,
  EVENT_NAME_MAP,
};
